<template>
  <div class="labeling-input">
    <input ref="cellinput" class="input" v-model="cell" v-bind="resetProps" v-if="type == 'input'" @blur="() => this.submitValue()" />
    <select ref="cellinput" class="input" v-model="cell" v-bind="resetProps" @change="() => this.submitValue()" v-if="type != 'input'">
      <option value="1%" selected>1%</option>
      <option value="7%">7%</option>
      <option value="8%">8%</option>
      <option value="16%">16%</option>
      <option value="0%">0%</option>
      <option value="2%">2%</option>
      <option value="45%">45</option>
      <option value="45%">45</option>
      <option value="22%">22%</option>
      <option value="6%">6%</option>
    </select>
  </div>
</template>

<script>
import Vue from "vue";
import "./styles.scss";
const LabelingInput = Vue.extend({
  name: "LabelingInput",

  props: {
    type: {
      default: "input",
    },
    value: {
      default: "",
    },
    valueKey: {},
    rowIndex: {},
    updateValue: {
      type: Function,
    },
  },
  methods: {
    submitValue() {
      this.updateValue(this.$refs.cellinput.value, this.valueKey, this.rowIndex);
    },
  },
  computed: {
    resetProps() {
      return { ...this.$attrs };
    },
    cell: {
      get: function () {
        return this.value;
      },
      set: function (newValue) {
        this.$emit("input", newValue);
        console.log("current input value ", this.$refs.cellinput.value);
      },
    },
  },
});
export default LabelingInput;
</script>
